module.exports = __webpack_public_path__ + "media/SchoolTalentShowSquareVideo-MadewithPosterMyWall.0cba3e6a.mp4";